import React from "react";
import {Link} from "react-router-dom";

import channel from "../helpers/channel_generator";
import Text from "../helpers/text";
import Vid from "../assets/loader.mov";

export default function Home(props){

    return(
        <main className="home">
            <video className="load-vid" autoPlay playsInline muted loop width={128} height={128}>
                <source src={Vid} type="video/mp4"/>
                Your browser does not support the video tag.
            </video> 
            <h1>Video Box</h1>
            <Link to={"/c/" + channel() } className="btn">{Text.actions.startCall}</Link>
        </main>
    )
}